import qs from 'qs';
import { isString } from './type-guards.js';

const parse = (urlPart, ignoreQueryPrefix = false)=>qs.parse(urlPart.substring(urlPart.indexOf('?') + 1), {
        ignoreQueryPrefix
    })
;
const stringify = (params, noQuestionMark = false, keyDivision = '&', valueDivision = '=', encode = true)=>valueDivision === '=' ? `${noQuestionMark ? '' : '?'}${qs.stringify(params, {
        delimiter: keyDivision,
        arrayFormat: 'comma',
        encode
    })}` : Object.entries(params).reduce((acc, [key, value], index)=>`${acc}${!index ? noQuestionMark ? '' : '?' : keyDivision}${key}${valueDivision}${value}`
    , '')
;
const toQueryParams = (params, noQuestionMark = false)=>Object.entries(params).reduce((acc, [key, value], index)=>`${acc}${!index ? noQuestionMark ? '' : '?' : '&'}${key}=${isString(value) ? value : stringify(value, true, '|', ':')}`
    , '')
;

export { parse, stringify, toQueryParams };
//# sourceMappingURL=query.js.map
